import { graphql } from 'gatsby';
import React, { ReactNode } from 'react';
import Footer from './Footer';
import Header from './Header';

type LayoutProps = {
  settings: Queries.SiteSettingsFragment | null;
  children: ReactNode;
};

const Layout = (props: LayoutProps) => {
  return (
    <>
      <Header settings={props.settings ?? null} nav={props.settings?.navigationItems ? props.settings.navigationItems : null} />
      <main className="text-center">{props.children}</main>
      <Footer settings={props.settings ?? null} nav={props.settings?.navigationItems ? props.settings.navigationItems : null} />
    </>
  );
};

export default Layout;

export const fragmentSection = graphql`
  fragment SiteSettings on ContentfulSiteSettings {
    siteTitle
    navigationItems {
      title
      contentful_id
      contentPage {
        slug
      }
      subNavigationItem {
        title
        contentful_id
        contentPage {
          slug
        }
      }
    }
  }
`;
